export const EMPTY_ACCOUNTS_FILTERS = {
  names: [],
  country: null,
  roleId: null,
  branchName: null,
  status: null,
};

export function countActiveAccountsFilters(filters) {
  let count = 0;
  if (filters.names?.length) count += 1;
  if (filters.country) count += 1;
  if (filters.roleId != null && filters.roleId !== "") count += 1;
  if (filters.branchName) count += 1;
  if (filters.status) count += 1;
  return count;
}

export function buildAccountsActiveChips(filters, roleOptions = [], branchOptions = []) {
  const chips = [];

  if (filters.names?.length) {
    const label = filters.names.map((n) => n.label).join(", ");
    chips.push({ id: "names", type: "names", label: `Name: ${label}` });
  }

  if (filters.country) {
    chips.push({
      id: "country",
      type: "country",
      label: `Country: ${filters.country}`,
    });
  }

  if (filters.roleId != null && filters.roleId !== "") {
    const roleName =
      roleOptions.find((r) => String(r.id) === String(filters.roleId))?.name ||
      filters.roleId;
    chips.push({ id: "role", type: "role", label: `Role: ${roleName}` });
  }

  if (filters.branchName) {
    chips.push({
      id: "branch",
      type: "branch",
      label: `Branch: ${filters.branchName}`,
    });
  }

  if (filters.status) {
    chips.push({
      id: "status",
      type: "status",
      label: `Status: ${filters.status}`,
    });
  }

  return chips;
}
